import axiosInstance from 'api/axios';

interface APIResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

interface IGenerateLogoFromTextRequestPayload {
  company_name: string;
  company_description: string;
  style: string;
  industry: string;
  tone: string;
  color: string;
  negative_prompt?: string;
  token?: string;
}

interface IGenerateImageFromTextResponse {
  logo: string;
}

interface ISaveGeneratedLogoPayload {
  logo: IGenerateLogoFromTextRequestPayload;
  user_id: string;
  url: string;
  name: string;
}

interface ISaveGeneratedImageResponse {
  data: string;
}

export interface ILogo {
  id: number;
  company_name: string;
  company_description: string;
  style: string;
  industry: string;
  tone: string;
  color: string;
  created_at: string;
  name: string;
  negative_prompt: string;
  url: string;
  user_id: string;
  user: any;
}

export interface IGetLogoResponse {
  logos: ILogo[];
}

export const LogoGenService = {
  // Generate logo from text
  generateLogoFromText: async (
    payload: IGenerateLogoFromTextRequestPayload
  ): Promise<APIResponse<IGenerateImageFromTextResponse>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/logo/generate-logo',
      payload
    );
    return response.data;
  },

  // Save logo
  saveGeneratedLogo: async (
    payload: ISaveGeneratedLogoPayload
  ): Promise<APIResponse<ISaveGeneratedImageResponse>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/logo/save-logo',
      payload
    );
    return response.data;
  },

  // Get all logos of a user
  getLogos: async (user_id: string): Promise<APIResponse<IGetLogoResponse>> => {
    const response = await axiosInstance.private.get(
      `/api/v1/logo/get-logos?user_id=${user_id}`
    );
    return response.data;
  },

  // Delete logo
  deleteLogo: async (logo_id: string): Promise<APIResponse<string>> => {
    const response = await axiosInstance.private.delete(
      `/api/v1/logo/delete-logo?logo_id=${logo_id}`
    );
    return response.data;
  },

  // Delete all logos
  deleteAllLogos: async (user_id: string): Promise<APIResponse<string>> => {
    const response = await axiosInstance.private.delete(
      `/api/v1/logo/delete-all-logos`,
      {
        params: {
          user_id,
        },
      }
    );
    return response.data;
  },
};
